export class JdsError extends Error {
    public readonly component: string;
    public readonly type: string;

    constructor(message: string, component: string, type: string = 'cancel') {
        super(message);
        this.name = 'JdsError';
        this.component = component;
        this.type = type;
    }
}